import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function ApiIntegrationCase() {
  return <CaseStudyPage slug="api-integration-platform" />;
}